import request from '../../utils/request'



// 产品精准投放渠道设置  

//---查询
export function getFilterPage(data){
  return request({
      url: `/product/eshop/srm/product/queryProductFilterOrgPage`,
      method: 'post',
      data,
  })
}
// 新增/ 更新
export function saveProductFilterOrg(data){
  return request({
      url: `/product/eshop/srm/product/saveProductFilterOrg`,
      method: 'post',
      data,
  })
}
export function updateProductFilterOrg(data){
  return request({
      url: `/product/eshop/srm/product/updateProductFilterOrg`,
      method: 'post',
      data,
  })
}

//单条删除
export function deleteProductFilterOrgById(data){
  return request({
      url: `/product/eshop/srm/product/deleteProductFilterOrgById/${data}`,
      method: 'get',
  })
}
//全删
export function deleteProductFilterOrg(data){
  return request({
      url: `/product/eshop/srm/product/deleteProductFilterOrg/${data}`,
      method: 'get',
      // data,
  })
}


// auth/release/getUserSimpleInfoByOrgCode
//getUserSimpleInfoByOrgCodes
//--- 人员名称的
export function getUserSimpleInfoFilter(data){
  return request({
      url: `/auth/release/getUserSimpleInfoFilter`,
      method: 'post',
      data,
  })
}
export function getUserSimpleInfoByOrgCodesFilter(data){
  return request({
      url: `/auth/release/getUserSimpleInfoByOrgCodesFilter`,
      method: 'get',
      params: data,
  })
}



//产品编辑权精准设置

//----查询
export function accuratesetQuery(data) {
  return request({
    url: '/product/eshop/srm/accurateset/query',
    method: 'post',
    data
  })
}

//----保存
export function accuratesetSave(data) {
  return request({
    url: '/product/eshop/srm/accurateset/saveSets',
    method: 'post',
    data
  })
}

//----保存开关
export function accuratesetSwitch(data) {
  return request({
    url: '/product/eshop/srm/accurateset/saveSwitch',
    method: 'post',
    data
  })
}



// 保存产品信息-收客限制信息
export function limitSave(data) {
  return request({
    url: '/product/eshop/srm/product/limit/saveOrUpdate',
    method: 'post',
    data
  })
}

// 保存产品信息-二返设置
export function secondReturnSave(data) {
  return request({
    url: '/product/eshop/srm/secondReturn/saveOrUpdate',
    method: 'post',
    data
  })
}

// 查询-二返设置
export function secondReturnQuery(data) {
  return request({
    url: `/product/eshop/srm/secondReturn/find/${data}?timeout=`+ new Date().getTime(),
    method: 'get',
    data
  })
}

// 保存产品信息-运营设置信息
export function operateSave(data) {
  return request({
    url: '/product/eshop/srm/product/operate/saveOrUpdate',
    method: 'post',
    data
  })
}

// 查看产品信息-运营设置信息
export function operateQuery(data) {
  return request({
    url: `/product/eshop/srm/product/operate/find/${data}`,
    method: 'get',
    data
  })
}

// 查看产品信息-收客限制信息
export function limitQuery(data) {
  return request({
    url: `/product/eshop/srm/product/limit/find/${data}?timeout=`+ new Date().getTime(),
    method: 'get',
    data
  })
}

// 保存产品信息-产品详情
export function detailsSave(data) {
  return request({
    url: '/product/eshop/srm/product/details/save',
    method: 'post',
    data
  })
}

// 保存产品信息-基础信息
export function saveProductBasic(data) {
  return request({
    url: '/product/eshop/srm/domestic/saveProductBasic',
    method: 'post',
    data
  })
}

// 查看产品基础信息
export function selectProductInfo(data) {
  return request({
    url: '/product/eshop/srm/domestic/selectProductInfo',
    method: 'post',
    data
  })
}

// 查看产品信息-产品详情
export function detailsQuery(data) {
  return request({
    url: `/product/eshop/srm/product/details/query/${data}`,
    method: 'get',
    data
  })
}

// 查询主题信息
export function getThemeList(data) {
  return request({
    url: '/product/eshop/srm/theme/getThemeList',
    method: 'post',
    data
  })
}

// 查看标签信息
export function getTagList(data) {
  return request({
    url: '/product/eshop/srm/tags/getTagList',
    method: 'post',
    data
  })
}

// 保存标签组信息
export function saveTagGroup(data) {
  return request({
    url: '/product/eshop/srm/tags/saveTagGroup',
    method: 'post',
    data
  })
}

// 保存标签信息
export function saveTag(data) {
  return request({
    url: '/product/eshop/srm/tags/saveTag',
    method: 'post',
    data
  })
}

// 获取产品详情
export function GetProductDetails(data) {
    return request({
      url: '/product/eshop/srm/product/productdetails',
      method: 'post',
      data
    })
}
// 保存历史记录
export function updateFeatureMapRecord(data) {
  return request({
    url: '/product/eshop/srm/product/updateFeatureMapRecord',
    method: 'post',
    data
  })
}
export function updateFeatureContent(data) {
  return request({
    url: '/product/eshop/srm/product/updateFeatureContent',
    method: 'post',
    data
  })
}
// 查看产品的团期列表
export function GetProductRegimentalList(data) {
  return request({
    url: '/inventory/eshop/productRegimental/list',
    method: 'post',
    data
  })
}

// 查看产品的团期列表 月
export function GetProductRegimentalMonth(data) {
  return request({
    url: '/inventory/eshop/productRegimental/month',
    method: 'post',
    data
  })
}

//保存产品的团期
export function ProductRegimentalSave(data) {
  return request({
    url: '/inventory/eshop/productRegimental/save',
    method: 'post',
    data
  })
}

//批量删除团期
export function ProductRegimentalDel(data) {
  return request({
    url: '/inventory/eshop/productRegimental/batchDelete',
    method: 'post',
    data
  })
}


//批量修改团期
export function BatchUpdateStockPrice(data) {
  return request({
    url: '/inventory/eshop/productRegimental/batchUpdateStockPrice',
    method: 'post',
    data
  })
}

//删除某一天团期
export function DeleteProductRegimental(productNo,day) {
  return request({
    url: `/inventory/eshop/productRegimental/delete/${productNo}/${day}`,
    method: 'post',

  })
}

export function GetCarGroupList(data) {
  return request({
    url: '/inventory/eshop/srm/productRegimental/save',
    method: 'post',
    data
  })
}
//获取境内游产品列表(分页)
export function GetDomesticProductList(data) {
  return request({
    url: '/product/eshop/srm/domestic/list',
    method: 'post',
    data
  })
}

//获取境外游产品列表(分页)
export function GetAbroadProductList(data) {
  return request({
    url: '/product/eshop/srm/abroad/list',
    method: 'post',
    data
  })
}

//获取周边游与一日游产品列表(分页)
export function GetSurroundingProductList(data) {
  return request({
    url: '/product/eshop/srm/surrounding/list',
    method: 'post',
    data
  })
}
//复制产品
export function CopyProduct(data) {
  return request({
    url: '/product/eshop/srm/product/copyProduct',
    method: 'post',
    data
  })
}
//删除产品
export function DeleteProduct(data) {
  return request({
    url: '/product/eshop/srm/product/deleteProduct',
    method: 'post',
    data
  })
}
//批量上下架
export function PutOrLowerProduct(data) {
  return request({
    url: '/product/eshop/srm/product/putorlowerproduct',
    method: 'post',
    data
  })
}
//产品批量移出-入回收站
export function PutRecycle(data) {
  return request({
    url: '/product/eshop/srm/product/putRecycle',
    method: 'post',
    data
  })
}
//获取操作记录列表
export function GetRecordList(data) {
  return request({
    url: '/product/eshop/srm/editRecord/list',
    method: 'get',
    params:data
  })
}
//同步助旅通产品
export function SyncZltProduct(data) {
  return request({
    url: '/product/eshop/srm/product/syncZltProduct',
    method: 'post',
    data
  })
}

// 修改境内游产品基础信息
export function updateProductBasic(data) {
  return request({
    url: '/product/eshop/srm/domestic/updateProductBasic',
    method: 'post',
    data
  })
}

// 保存周边游基础信息
export function saveSurroundingProductBasic(data) {
  return request({
    url: '/product/eshop/srm/surrounding/saveProductBasic',
    method: 'post',
    data
  })
}

// 查询单个周边游产品基础信息
export function selectSurroundingProductInfo(data) {
  return request({
    url: '/product/eshop/srm/surrounding/selectProductInfo',
    method: 'post',
    data
  })
}

// 修改周边游产品基础信息
export function updateSurroundingProductBasic(data) {
  return request({
    url: '/product/eshop/srm/surrounding/updateProductBasic',
    method: 'post',
    data
  })
}

// 保存境外游产品基础信息
export function saveAbroadProductBasic(data) {
  return request({
    url: '/product/eshop/srm/abroad/saveProductBasic',
    method: 'post',
    data
  })
}

// 查询单个境外游产品基础信息
export function selectAbroadProductInfo(data) {
  return request({
    url: '/product/eshop/srm/abroad/selectProductInfo',
    method: 'post',
    data
  })
}

// 修改境外游产品基础信息
export function updateAbroadProductBasic(data) {
  return request({
    url: '/product/eshop/srm/abroad/updateProductBasic',
    method: 'post',
    data
  })
}

// 保存邮轮游游产品基础信息
export function saveCruiseProductBasic(data) {
  return request({
    url: '/product/eshop/srm/cruise/saveProductBasic',
    method: 'post',
    data
  })
}

// 查询单个邮轮游产品基础信息
export function selectCruiseProductInfo(data) {
  return request({
    url: '/product/eshop/srm/cruise/selectProductInfo',
    method: 'post',
    data
  })
}

// 修改邮轮游产品基础信息
export function updateCruiseProductBasic(data) {
  return request({
    url: '/product/eshop/srm/cruise/updateProductBasic',
    method: 'post',
    data
  })
}

// 发布产品-周边游
export function surroundingReleaseProduct(data) {
  return request({
    url: '/product/eshop/srm/surrounding/releaseProduct',
    method: 'post',
    data
  })
}
// 发布产品-境内游
export function domesticReleaseProduct(data) {
  return request({
    url: '/product/eshop/srm/domestic/releaseProduct',
    method: 'post',
    data
  })
}
// 发布产品-境外游
export function abroadReleaseProduct(data) {
  return request({
    url: '/product/eshop/srm/abroad/releaseProduct',
    method: 'post',
    data
  })
}
// 发布产品-邮轮游
export function cruiseReleaseProduct(data) {
  return request({
    url: '/product/eshop/srm/cruise/releaseProduct',
    method: 'post',
    data
  })
}
// 上传产品的海报图片(周边一日)
export function saveProductPosterUrlSurrounding(data) {
  return request({
    url: '/product/eshop/srm/surrounding/saveProductPosterUrl',
    method: 'post',
    data
  })
}
// 上传产品的海报图片(境内)
export function saveProductPosterUrlDomestic(data) {
  return request({
    url: '/product/eshop/srm/domestic/saveProductPosterUrl',
    method: 'post',
    data
  })
}
// 上传产品的海报图片(境外)
export function saveProductPosterUrlAbroad(data) {
  return request({
    url: '/product/eshop/srm/abroad/saveProductPosterUrl',
    method: 'post',
    data
  })
}
// 上传产品的海报图片(邮轮)
export function saveProductPosterUrlCruise(data) {
  return request({
    url: '/product/eshop/srm/cruise/saveProductPosterUrl',
    method: 'post',
    data
  })
}

// 获取所有类型产品筛选条件
export function productScreen(data) {
  return request({
    url: '/product/eshop/srm/product/screen',
    method: 'post',
    data
  })
}

// 批量修改占位时效
export function batchUpdateSeizeSeat(data) {
  return request({
    url: '/product/eshop/srm/product/batchUpdateSeizeSeat',
    method: 'post',
    data
  })
}

// 获取所有类型产品列表
export function productList(data) {
  return request({
    url: '/product/eshop/srm/product/list',
    method: 'post',
    data
  })
}

// 查询产品分组列表
export function productGroup(params) {
  return request({
    url: '/product/eshop/srm/group',
    method: 'get',
    params
  })
}

// 修改产品分组列表
export function updateGroup(data) {
  return request({
    url: '/product/eshop/srm/group',
    method: 'put',
    data
  })
}

// 新增产品分组列表
export function saveGroup(data) {
  return request({
    url: '/product/eshop/srm/group',
    method: 'post',
    data
  })
}

// 校验主题来源是否是系统新增
export function checkThemeSource(params) {
  return request({
    url: '/product/eshop/srm/theme/checkThemeSource',
    method: 'get',
    params
  })
}
// 查询单个产品的指定日期的价格库存信息
export function stockPrice(data) {
  return request({
    url: '/inventory/eshop/productRegimental/stockPrice',
    method: 'post',
    data
  })
}

// 单个日期甩位设置
export function promote(data) {
  return request({
    url: '/inventory/eshop/productRegimental/promote',
    method: 'post',
    data
  })
}

// 查询当前组织已设置的所有区域
export function queryAllAreaByOrgCode(params) {
  return request({
    url: '/product/eshop/srm/group/queryAllAreaByOrgCode',
    method: 'get',
    params
  })
}

// 查询当前组织已设置的所有区域
export function queryAllAreaByOrgCodeRecommend(params) {
  return request({
    url: '/product/eshop/srm/recommend/queryAllAreaByOrgCode',
    method: 'get',
    params
  })
}

// 根据产品类型业务区域查询分组列表
export function QueryGroupList(params) {
  return request({
    url: '/product/eshop/srm/group/QueryGroupList',
    method: 'get',
    params
  })
}

// 查询产品推荐列表（分页）
export function productRecommend(params) {
  return request({
    url: '/product/eshop/srm/recommend',
    method: 'get',
    params
  })
}

// 产品推荐新增
export function saveRecommend(data) {
  return request({
    url: '/product/eshop/srm/recommend',
    method: 'post',
    data
  })
}

// 产品推荐修改
export function updateRecommend(data) {
  return request({
    url: '/product/eshop/srm/recommend',
    method: 'put',
    data
  })
}

// 获取产品关联推荐
export function productDetailRecommend(params) {
  return request({
    url: '/product/eshop/srm/product/recommend',
    method: 'get',
    params
  })
}

// 检查该产品的产品详情页面是否被修改过
export function checkProductDetails (params) {
  return request({
    url: `/product/eshop/srm/productOrder/checkProductDetails`,
    method: 'get',
    params
  })
} 

// 产品关联推荐删除整行
export function recommendDelete(id) {
  return request({
    url: `/product/eshop/srm/recommend/${id}`,
    method: 'delete',
  })
}

// 产品分组删除整行
export function groupDelete(id) {
  return request({
    url: `/product/eshop/srm/group/${id}`,
    method: 'delete',
  })
}

// 产品分组单独删除
export function groupDeleteOne(id) {
  return request({
    url: `product/eshop/srm/group/groupCode/${id}`,
    method: 'delete',
  })
}

// 批量产品删除
export function batchDeleteProduct(data) {
  return request({
    url: '/product/eshop/srm/product/batchDeleteProduct',
    method: 'post',
    data
  })
}

// 新增,修改签证资料
export function saveInformation(data) {
  return request({
    url: '/product/eshop/srm/information/saveInformation',
    method: 'post',
    data
  })
} 

// 查看签证资料
export function queryInformation(data) {
  return request({
    url: '/product/eshop/srm/information/queryInformation',
    method: 'post',
    data
  })
} 

// 删除签证资料
export function deleteInformation(data) {
  return request({
    url: '/product/eshop/srm/information/deleteInformation',
    method: 'delete',
    data
  })
} 
// 签证资料操作日志
export function selectRecord(data) {
  return request({
    url: '/product/eshop/srm/record/selectRecord',
    method: 'get',
    params:data
  })
} 

// 修改产品上的产品亮点
export function setProductReason(data) {
  return request({
    url: '/product/eshop/srm/product/updatesales',
    method: 'post',
    data
  })
} 
//erp产品列表
export function findPageErpProduct(data){
  return request({
      url: '/product/eshop/srm/eproduct/findPage',
      method: 'post',
      data
  })
}

//erp产品详情
export function getInfoErpProduct(data){
  return request({
      url: '/product/eshop/srm/eproduct/getInfo',
      method: 'post',
      data
  })
}





// WEBPACK FOOTER //
// ./src/SRM/api/product.js